module.exports = __webpack_public_path__ + "static/media/Bebas-Neue.1e0f30e2.svg";